'use strict';
import * as $j_app$002e$002dEndpoints$0024 from "./app.-Endpoints$.js";
import * as $j_app$002edata$002e$002dApp$002dUser$002dRegistration$002dState from "./app.data.-App-User-Registration-State.js";
import * as $j_app$002edata$002e$002dUser$002dKind$0024$002dMember from "./app.data.-User-Kind$-Member.js";
import * as $j_app$002edata$002e$002dUser$002dKind$0024$002dViewer from "./app.data.-User-Kind$-Viewer.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppUserRegistrationState$() {
}
export { $c_Lapp_data_AppUserRegistrationState$ as $c_Lapp_data_AppUserRegistrationState$ };
$p = $c_Lapp_data_AppUserRegistrationState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppUserRegistrationState$;
/** @constructor */
function $h_Lapp_data_AppUserRegistrationState$() {
}
export { $h_Lapp_data_AppUserRegistrationState$ as $h_Lapp_data_AppUserRegistrationState$ };
$h_Lapp_data_AppUserRegistrationState$.prototype = $p;
$p.bMr = (function(user, data) {
  var x23 = data.Xd;
  if ((x23 instanceof $j_app$002edata$002e$002dUser$002dKind$0024$002dViewer.$c_Lapp_data_UserKind$Viewer)) {
    var x29 = x23.LV;
    return new $j_app$002edata$002e$002dApp$002dUser$002dRegistration$002dState.$c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer(user, data.Kj, data.Ki, data.Kk, new $j_app$002edata$002e$002dUser$002dKind$0024$002dViewer.$c_Lapp_data_UserKind$Viewer(x29));
  }
  if ((x23 instanceof $j_app$002edata$002e$002dUser$002dKind$0024$002dMember.$c_Lapp_data_UserKind$Member)) {
    var x26 = x23.Ya;
    return new $j_app$002edata$002e$002dApp$002dUser$002dRegistration$002dState.$c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember(user, data.Kj, data.Ki, data.Kk, new $j_app$002edata$002e$002dUser$002dKind$0024$002dMember.$c_Lapp_data_UserKind$Member(x26));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x23);
});
$p.bWv = (function(signal, onRegisteredAsViewer, onRegisteredAsOrganizationMember) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lcom_raquo_airstream_split_SplitMatchOneMacros$__toSplittableOneObservable__Lcom_raquo_airstream_core_BaseObservable__sci_Seq__Lcom_raquo_airstream_core_Observable($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_split_SplitMatchOneMacros$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((i) => {
    if ((i instanceof $j_app$002edata$002e$002dApp$002dUser$002dRegistration$002dState.$c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 0, i);
    }
    if ((i instanceof $j_app$002edata$002e$002dApp$002dUser$002dRegistration$002dState.$c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 1, i);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(i);
  })), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([onRegisteredAsViewer, onRegisteredAsOrganizationMember])));
});
$p.EG = (function(orgMember) {
  return orgMember.Lz.ah6().ky(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((data) => data)));
});
$p.bwx = (function(orgMember) {
  return orgMember.Lz.bwy().ky(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((v1) => new $j_app$002e$002dEndpoints$0024.$c_Lapp_data_CookieAppAuthData(((v1 === null) ? null : v1.oU)))));
});
$p.auZ = (function(signal) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_SignalExts$package$().ah3(signal).jf(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$7) => $m_Lapp_data_AppUserRegistrationState$().EG(_$7))));
});
$p.dl = (function(x) {
  return x.co();
});
var $d_Lapp_data_AppUserRegistrationState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppUserRegistrationState$, "app.data.AppUserRegistrationState$", ({
  CE: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_AppUserRegistrationState$ as $d_Lapp_data_AppUserRegistrationState$ };
var $n_Lapp_data_AppUserRegistrationState$;
function $m_Lapp_data_AppUserRegistrationState$() {
  if ((!$n_Lapp_data_AppUserRegistrationState$)) {
    $n_Lapp_data_AppUserRegistrationState$ = new $c_Lapp_data_AppUserRegistrationState$();
  }
  return $n_Lapp_data_AppUserRegistrationState$;
}
export { $m_Lapp_data_AppUserRegistrationState$ as $m_Lapp_data_AppUserRegistrationState$ };
//# sourceMappingURL=app.data.-App-User-Registration-State$.js.map
